<template>
  <div :style="fullscreen ? fullStyle : null">
    <!-- FILTROS -->
    <div v-if="showFilters" class="col-12 d-flex align-center justify-center">
      <v-autocomplete
        v-model="filtros.idAreas"
        :items="areas"
        item-text="nombre"
        item-value="idArea"
        label="Áreas"
        clearable multiple hide-details
        :loading="loadingAreas" :disabled="loading" class="mx-2"
      />
      <v-autocomplete
        v-model="filtros.idMaquinasIns"
        :items="instancias"
        :item-text="nombreMaquina"
        item-value="idMaquinaIns"
        label="Máquinas instancias"
        clearable multiple hide-details
        :loading="loadingInstancias" :disabled="loading" class="mx-2"
      />
      <datePicker v-model="filtros.desde" format="YYYY-MM-DD" label="Desde" clearable maxToday
        :disabled="loading" class="mx-2"/>
      <datePicker v-model="filtros.hasta" format="YYYY-MM-DD" label="Hasta" clearable maxToday
        :disabled="loading" class="mx-2"/>
      <v-btn color="primary" class="mx-2" :disabled="!realizarPeticion || loading" @click="obtenerDatos">
        <v-icon left>mdi-magnify</v-icon> Consultar
      </v-btn>
    </div>

    <!-- SALIR FULLSCREEN -->
    <div class="text-subtitle-1 font-weight-medium">
      <div v-if="fullscreen" class="d-flex justify-end">
        <v-btn text color="primary" @click="$emit('close')">
          <v-icon left>mdi-keyboard-return</v-icon> Cerrar Vista
        </v-btn>
      </div>
    </div>

    <!-- RESUMEN PERÍODO -->
    <v-alert v-if="tieneResumen" type="info" border="left" colored-border class="mb-3">
      <div class="d-flex align-center flex-wrap">
        <strong class="mr-4">Resumen del periodo</strong>
        <div class="mr-4">OK: {{ nf(resumenPeriodo.piezasOkTotales) }}</div>
        <div class="mr-4">NoOK: {{ nf(resumenPeriodo.piezasNoOkTotales) }}</div>
        <div class="mr-4">Teóricas: {{ nf(resumenPeriodo.piezasTeoricasTotales) }}</div>
        <div class="mr-4">A: {{ pf(resumenPeriodo.disponibilidad) }}</div>
        <div class="mr-4">P: {{ pf(resumenPeriodo.rendimiento) }}</div>
        <div class="mr-4">Q: {{ pf(resumenPeriodo.calidad) }}</div>
        <div class="mr-4"><strong>OEE: {{ pf(resumenPeriodo.oee) }}</strong></div>
        <v-spacer/>
        <div class="text-caption">Próxima actualización en {{ timeFormatted }}</div>
      </div>
    </v-alert>

    <!-- ESTADOS -->
    <v-col cols="12">
      <v-col v-if="loading" cols="12" class="text-center">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate/>
        <h2>Cargando...</h2>
      </v-col>

      <v-col v-else-if="areasTurnos.length === 0" cols="12">
        <v-alert color="blue-grey" text class="mb-0">
          <div class="text-center" style="font-size: 16px">
            Selecciona filtros y presiona <strong>Consultar</strong>.
          </div>
        </v-alert>
      </v-col>
      <!-- MATRIZ: ÁREA → TURNO (filas = horas, columnas = máquinas) con filas desplegables por día -->
<v-col v-else cols="12">
  <v-expansion-panels multiple v-model="expandedAreas">

    <!-- Área -->
    <v-expansion-panel v-for="(area, ia) in areasTurnos" :key="'a-'+ia">
      <v-expansion-panel-header class="font-weight-600">
        <div class="d-flex align-center w-100">
          <div><h5>{{ area.nombre || 'Área N/D' }}</h5></div>
          <v-spacer/>
          <!-- Acciones por Área -->
          <v-btn small text class="mr-2" @click.stop="openAllTurnos(ia)">Abrir turnos</v-btn>
          <v-btn small text class="mr-2" @click.stop="closeAllTurnos(ia)">Cerrar turnos</v-btn>
          <span class="text-caption grey--text">Turnos: {{ area.turnos.length }}</span>
          <!-- Chevron para abrir/cerrar SOLO esta área -->
          <v-btn icon @click.stop="toggleArea(ia)">
            <v-icon>{{ isAreaOpen(ia) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          </v-btn>
        </div>
      </v-expansion-panel-header>

      <v-expansion-panel-content>

        <!-- Turno (NO hay panel por día arriba) -->
        <v-expansion-panels
        multiple
        :value="expandedTurnos[ia] || []"
        @input="val => setTurnos(ia, val)"
        >
          <v-expansion-panel v-for="(t, it) in area.turnos" :key="'t-'+ia+'-'+it">
            <v-expansion-panel-header class="font-weight-600">
              <div class="d-flex align-center w-100">
                <div>
                  Turno {{ t.turno }}
                  <span class="grey--text text--darken-1">
                    ({{ t.turno === 1 ? '07:00–19:00' : '19:00–07:00' }})
                  </span>
                </div>
                <v-spacer/>
                <span class="text-caption grey--text mr-2">
                  Máquinas: {{ t.maquinasOrdenadas.length }} • Horas: {{ t.horas.length }}
                </span>

                <!-- Chevron para abrir/cerrar SOLO este turno -->
              <v-btn icon @click.stop="toggleTurno(ia, it)">
                <v-icon>{{ isTurnoOpen(ia, it) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <div class="table-wrap" :class="{ compacto }">
                <table class="matriz">
                  <thead>
                    <tr>
                      <th class="sticky-col">Hora</th>
                      <th v-for="m in t.maquinasOrdenadas" :key="'m-'+m" class="text-center sticky-top">
                        {{ m }}
                      </th>
                      <th v-if="mostrarTotales" class="text-center sticky-top">Total</th>
                      <th class="sticky-top" style="width:44px;"></th>
                    </tr>
                  </thead>

                  <tbody
                    v-for="(fila, idx) in t.horas"
                    :key="`b-${ia}-${it}-${fila.key}`"
                    >
                      <tr :key="`h-${ia}-${it}-${fila.key}`">
                        <td class="sticky-col">{{ fila.rango }}</td>

                        <td
                        v-for="m in t.maquinasOrdenadas"
                        :key="`c-${ia}-${it}-${fila.key}-${m}`"
                        class="cell"
                        :style="bgStyle(getOee(fila, m))"
                        :class="{ alerta: (getOee(fila, m) < umbralRojo) }"
                        >
                          <v-tooltip :nudge-left="50"
									bottom
									color="white"
									class="black--text">
                            <template #activator="{ on, attrs }">
                              <div class="cell-content">
                                <div class="oee oee-lg">{{ pct(getOee(fila, m)) }}</div>
                                <!-- línea de A · P · Q solo si se quiere -->
                                <div v-if="mostrarAPQ" class="mini">
                                  A {{ pct(getVal(fila, m, 'A')) }} ·
                                  P {{ pct(getVal(fila, m, 'P')) }} ·
                                  Q {{ pct(getVal(fila, m, 'Q')) }}
                                </div>
                              </div>
                            </template>
                            <div v-if="hasData(fila, m)">
                              <div><b>{{ m }}</b> — {{ fila.rango }} (promedio del período)</div>
                              <div>OK: {{ nf(getVal(fila, m, 'ok')) }}</div>
                              <div>Teóricas: {{ nf(getVal(fila, m, 'teoricas')) }}</div>
                              <div>A: {{ pct(getVal(fila, m, 'A')) }} · P: {{ pct(getVal(fila, m, 'P')) }} · Q: {{ pct(getVal(fila, m, 'Q')) }}</div>
                              <div><b>OEE: {{ pct(getOee(fila, m)) }}</b></div>
                            </div>
                            <div v-else>Sin datos</div>
                          </v-tooltip>
                        </td>

                        <!-- Totales por hora -->
                        <td v-if="mostrarTotales" class="cell total">
                          <div class="oee oee-lg">{{ pct(fila.total && fila.total.OEE) }}</div>
                            <div class="mini">
                            OK {{ nfsafe(fila.total && fila.total.ok) }}
                            · T {{ nfsafe(fila.total && fila.total.teoricas) }}
                            </div>
                            </td>

                        <!-- Botón expandir -->
                        <td class="text-center">
                          <v-btn icon color="black" small @click="toggleRow(ia, it, fila.key)">
                            <v-icon>{{ isExpanded(ia, it, fila.key) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          </v-btn>
                        </td>
                      </tr>

                      <!-- Fila detalle (por día) -->
                      <tr v-if="isExpanded(ia, it, fila.key)" :key="`hdet-${ia}-${it}-${fila.key}`">
                        <td :colspan="t.maquinasOrdenadas.length + (mostrarTotales ? 2 : 1) + 1" style="background:#f7f9fc; padding:0;">
                          <div class="detalle-wrap">
                            <table class="subtabla">
                                <thead>
                                <tr>
                                    <th class="sticky-col">Día</th>
                                    <th v-for="m in t.maquinasOrdenadas" :key="'dh-'+m" class="text-center">
                                    {{ m }}
                                    </th>
                                    <th v-if="mostrarTotales" class="text-center">Total</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr
                                v-for="(d, iday) in fila.detalleDias"
                                :key="`day-${ia}-${it}-${fila.key}-${iday}`"
                                >
                                    <!-- Columna Día -->
                                    <td class="sticky-col">
                                    <div class="font-weight-bold">Día {{ iday+1 }}</div>
                                    <div class="text--secondary" style="font-size:11px">{{ d.fechaProd }}</div>
                                    </td>

                                    <!-- Una celda por máquina -->
                                    <td
                                    v-for="m in t.maquinasOrdenadas"
                                    :key="`dmc-${ia}-${it}-${fila.key}-${iday}-${m}`"
                                    class="cell"
                                    :style="bgStyle(getOeeDia(d, m))"
                                    >
                                    <div v-if="d.maquinas[m]" class="cell-content">
                                        <!-- antes: pct(d.maquinas[m].OEE) -->
                                        <div class="oee">{{ pct(getOeeDia(d, m)) }}</div>
                                        <div v-if="mostrarAPQ" class="mini">
                                        A {{ pct(getValDia(d, m, 'A')) }} ·
                                        P {{ pct(getValDia(d, m, 'P')) }} ·
                                        Q {{ pct(getValDia(d, m, 'Q')) }}
                                        </div>
                                    </div>
                                    <div v-else class="cell-content">—</div>
                                    </td>

                                    <!-- Total del día -->
                                    <td v-if="mostrarTotales" class="cell total">
                                    <div class="oee oee-lg">{{ pct(d.total.OEE) }}</div>
                                    <div class="mini">
                                        OK {{ nf(d.total.ok) }} · T {{ nf(d.total.teoricas) }}
                                    </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- (Opcional) Botones globales arriba o abajo -->
        <div class="d-flex justify-end mt-2">
        <v-btn small text class="mr-2" @click="openAllAreas">Expandir todas las áreas</v-btn>
        <v-btn small text @click="closeAllAreas">Colapsar todas las áreas</v-btn>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
</v-col>
    </v-col>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex/dist/vuex.common.js'

export default {
  name: 'ReporteDetalladoHoraMatriz',
  props: {
    fullscreen: { type: Boolean, default: false },
    showFilters: { type: Boolean, default: true },
    ordenColumnas: { type: String, default: 'alfabetico' }, // 'alfabetico' | 'oee'
    umbralRojo: { type: Number, default: 60 },
    mostrarTotales: { type: Boolean, default: true },
    compacto: { type: Boolean, default: false },
    agruparPorDia: { type: Boolean, default: true },   // <<--- agrega esto
    mostrarAPQ: { type: Boolean, default: false } // 👈 NUEVO (apagado por default)
    },
  data () {
    const minutesDefault = 5
    const totalMs = minutesDefault * 60 * 1000
    return {
      filtros: { idAreas: [], idMaquinasIns: [], desde: null, hasta: null },
      response: null,
      areas: [],
      instancias: [],
      loading: false,
      loadingAreas: false,
      loadingInstancias: false,
      // timer
      minutes: minutesDefault,
      totalMs,
      remainingMs: totalMs,
      isRunning: false,
      intervalId: null,
      endAt: null,
      // filas expandidas
      expanded: new Set(), // keys "ia|it|hourKey"
      expandedAreas: [],          // <--- control de paneles de ÁREA
      expandedTurnos: {},         // <--- control por área: { [ia]: number[] }
    }
  },
  computed: {
    ...mapState({ nombreEmpresa: 'nombreEmpresa' }),
    realizarPeticion () { return !!(this.filtros.desde && this.filtros.hasta) },

    resumenPeriodo () {
      return this.response?.resumenPeriodo ?? {
        piezasOkTotales: 0, piezasNoOkTotales: 0, piezasTeoricasTotales: 0,
        disponibilidad: 0, rendimiento: 0, calidad: 0, oee: 0
      }
    },
    tieneResumen () { return !!this.response?.resumenPeriodo },

    /**
     * Salida:
     * [
     *  { nombre, turnos: [
     *     { turno, maquinasOrdenadas:[], horas:[
     *        { key, rango, maquinas:{[m]:{ok,teoricas,A,P,Q,OEE}}, total:{}, detalleDias:[
     *            { fechaProd, maquinas:{[m]:{ok,teoricas,A,P,Q,OEE}}, total:{} }
     *        ]}
     *     ]}
     *  ]}
     * ]
     */
    areasTurnos () {
  const resultados = this.response?.resultados || []
  if (!Array.isArray(resultados) || resultados.length === 0) return []

  // area -> turno -> { maquinas:Set, horas:Map }
  const mapArea = new Map()

  for (const r of resultados) {
    const areaNombre = r?.area || 'Área N/D'
    const maq        = r?.maquina || 'Sin máquina'
    const horasSrc   = r?.outV2?.horas || []
    const fechaBase = r?.fecha || this.filtros.desde || this.filtros.hasta

    if (!mapArea.has(areaNombre)) mapArea.set(areaNombre, new Map())
    const mapTurno = mapArea.get(areaNombre)

    for (const h of horasSrc) {
      // Determinar turno por HORA (07:00–19:00 = 1, 19:00–07:00 = 2) y fechaProd (día contable)
      const { turno, fechaProd } = this.resolveTurnoYDia(h?.desdeHora, fechaBase)
      const diaKey = fechaProd || r?.fecha || this.filtros.desde || 'N/D'; // <-- asegúrate de definirlo
      if (!mapTurno.has(turno)) mapTurno.set(turno, { maquinas: new Set(), horas: new Map() })
      const bucket = mapTurno.get(turno)
      bucket.maquinas.add(maq)

      // Clave por minuto de inicio
      const [H, M] = String(h?.desdeHora || '00:00').split(':').slice(0,2).map(n => +n || 0)
      const keyMin = H * 60 + M

      if (!bucket.horas.has(keyMin)) {
        bucket.horas.set(keyMin, {
            key: keyMin,
            // 👇 orden de visualización: en Turno 2, 00:00–06:59 van al final
            orderKey: (turno === 2 && keyMin < 420) ? keyMin + 1440 : keyMin,
            rango: `${h?.desdeHora || '--:--'} - ${h?.hastaHora || '--:--'}`,
            maquinas: {},
            detalleDias: new Map()
        })
      }
      const fila = bucket.horas.get(keyMin)

      const rh  = h?.resumen?.hora || {}
        const reg = {
        ok:       Number(h?.piezasOkHora ?? 0),
        noOk:     Number(h?.piezasNoOkHora ?? 0),
        teoricas: Number(h?.piezasEsperadasTeoricasHora ?? 0),
        A:        Number(rh?.disponibilidad ?? 0),
        P:        Number(rh?.rendimiento ?? 0),
        Q:        Number(rh?.calidad ?? 0),
        OEE:      Number(rh?.oee ?? 0) // <- EXACTAMENTE el del EP
        }

      // acumulado período por máquina (para la fila agregada)
        if (!fila.maquinas[maq]) {
        fila.maquinas[maq] = {
            ok:0, noOk:0, teoricas:0,
            aSum:0, pSum:0, qSum:0, oeeSum:0,
            count:0, wTeo:0
        }
        }
        const acc = fila.maquinas[maq]            // ← FALTABA

        const carga = reg.teoricas > 0

        acc.ok       += reg.ok
        acc.noOk     += reg.noOk
        acc.teoricas += reg.teoricas

        if (carga) {
            acc.aSum   += reg.A
            acc.pSum   += reg.P
            acc.qSum   += reg.Q
            acc.oeeSum += reg.OEE
            acc.count  += 1
            acc.wTeo   += reg.teoricas
        }

      // desglose por día
      if (!fila.detalleDias.has(diaKey)) {
        fila.detalleDias.set(diaKey, { fechaProd: diaKey, maquinas: {} })
        }
        fila.detalleDias.get(diaKey).maquinas[maq] = reg
    }
  }

  // Serializar -> [{ nombre, turnos:[{ turno, maquinasOrdenadas, horas:[...] }] }]
  const out = []
  for (const [areaNombre, mapTurno] of mapArea.entries()) {
    const turnos = []

    for (const [turno, t] of mapTurno.entries()) {
      const maquinas = Array.from(t.maquinas)
      const horas = Array.from(t.horas.values()).sort((a, b) => a.orderKey - b.orderKey)

      horas.forEach(h => {
        // Promedios por máquina
maquinas.forEach(m => {
  const a = h.maquinas[m]
  if (a) {
    const w = a.wTeo || 0
    const hasCarga = w > 0 && a.count > 0
    h.maquinas[m] = {
      ok: a.ok,
      noOk: a.noOk,
      teoricas: a.teoricas,
      // si querés, aquí puedes ponderar por w; ahora va por conteo
      A: hasCarga ? (a.aSum / a.count) : 0,
      P: hasCarga ? (a.pSum / a.count) : 0,
      Q: hasCarga ? (a.qSum / a.count) : 0,
      OEE: hasCarga ? (a.oeeSum / a.count) : 0
    }
  }
})

// Totales por hora (columna "Total")
const vals   = maquinas.map(m => h.maquinas[m]).filter(Boolean)
const sumTeo = vals.reduce((s,x)=> s + (x.teoricas || 0), 0)
const meanW  = k => sumTeo > 0
  ? vals.reduce((s,x)=> s + Number(x[k] || 0) * Number(x.teoricas || 0), 0) / sumTeo
  : 0

const A = meanW('A'), P = meanW('P'), Q = meanW('Q')

const tot = {
  ok:       vals.reduce((s,x)=> s + (x.ok   || 0), 0),
  noOk:     vals.reduce((s,x)=> s + (x.noOk || 0), 0),
  teoricas: sumTeo,
  OEE:      sumTeo > 0 ? (A * P * Q) / 10000 : 0
}
h.total = tot

// detalleDias(Map) -> Array + total por día (ponderado por teóricas)
const detalleArr = []
for (const [f, det] of h.detalleDias.entries()) {
  const porMaq   = det.maquinas
  const list     = maquinas.map(m => porMaq[m]).filter(Boolean)
  const sumTeoD  = list.reduce((s,x)=> s + (x?.teoricas || 0), 0)
  const Ad = sumTeoD > 0 ? list.reduce((s,x)=> s + Number(x.A || 0) * Number(x.teoricas || 0), 0) / sumTeoD : 0
  const Pd = sumTeoD > 0 ? list.reduce((s,x)=> s + Number(x.P || 0) * Number(x.teoricas || 0), 0) / sumTeoD : 0
  const Qd = sumTeoD > 0 ? list.reduce((s,x)=> s + Number(x.Q || 0) * Number(x.teoricas || 0), 0) / sumTeoD : 0

  const totalDia = {
    ok:       list.reduce((s,x)=> s + (x?.ok || 0), 0),
    teoricas: sumTeoD,
    OEE:      sumTeoD > 0 ? (Ad * Pd * Qd) / 10000 : 0
  }
  detalleArr.push({ fechaProd: f, maquinas: porMaq, total: totalDia })
}
h.detalleDias = detalleArr.sort((a,b)=> String(a.fechaProd).localeCompare(String(b.fechaProd)))
      })

      // Orden de columnas
      const oeeProm = {}
      maquinas.forEach(m => { oeeProm[m] = [] })
      horas.forEach(h => {
        maquinas.forEach(m => {
          const d = h.maquinas[m]
          if (d && d.OEE != null) oeeProm[m].push(d.OEE)
        })
      })
      const prom = m => (oeeProm[m]?.length ? oeeProm[m].reduce((a,x)=>a+x,0)/oeeProm[m].length : 0)
      let maquinasOrdenadas = [...maquinas].sort()
      if (this.ordenColumnas === 'oee') maquinasOrdenadas.sort((a,b)=>prom(b)-prom(a))

      turnos.push({ turno, maquinasOrdenadas, horas })
    }

    turnos.sort((a,b)=>a.turno-b.turno)
    out.push({ nombre: areaNombre, turnos })
  }

  return out.sort((a,b)=>a.nombre.localeCompare(b.nombre))
},

    // timer
    minutesLeft () { return Math.floor(this.remainingMs / 60000) },
    secondsLeft () { return Math.floor((this.remainingMs % 60000) / 1000) },
    timeFormatted () { return `${this.pad(this.minutesLeft)}:${this.pad(this.secondsLeft)}` },
    fullStyle () {
      return { position:'fixed', top:0, left:0, right:0, bottom:0, zIndex:2001, background:this.$vuetify?.theme?.dark ? '#121212' : '#fff', padding:'16px', overflow:'auto' }
    }
  },
  methods: {
    setTurnos (ia, val) {
    // asegura array y reactividad
    this.$set(this.expandedTurnos, ia, Array.isArray(val) ? val : [])
    },
    // ----- ÁREAS -----
    isAreaOpen (ia) {
        return this.expandedAreas.includes(ia)
    },
    toggleArea (ia) {
        const i = this.expandedAreas.indexOf(ia)
        if (i >= 0) this.expandedAreas.splice(i, 1)
        else this.expandedAreas.push(ia)
        // forzar reactividad
        this.expandedAreas = [...this.expandedAreas]
    },
    openAllAreas () {
        this.expandedAreas = this.areasTurnos.map((_, ia) => ia)
    },
    closeAllAreas () {
        this.expandedAreas = []
    },

    // ----- TURNOS -----
    ensureStore (ia) {
        if (!Array.isArray(this.expandedTurnos[ia])) {
            this.$set(this.expandedTurnos, ia, [])
        }
    },
    isTurnoOpen (ia, it) {
        this.ensureStore(ia)
        return this.expandedTurnos[ia].includes(it)
    },
    toggleTurno (ia, it) {
        this.ensureStore(ia)
        const arr = [...this.expandedTurnos[ia]]
        const i = arr.indexOf(it)
        if (i >= 0) arr.splice(i, 1); else arr.push(it)
        this.$set(this.expandedTurnos, ia, arr)
    },
    openAllTurnos (ia) {
        const n = this.areasTurnos[ia]?.turnos?.length || 0
        this.$set(this.expandedTurnos, ia, Array.from({ length: n }, (_, i) => i))
    },
    closeAllTurnos (ia) {
        this.$set(this.expandedTurnos, ia, [])
    },
    // ---- expand/collapse ----
    rowKey (ia, it, hourKey) { return `${ia}|${it}|${hourKey}` },
    isExpanded (ia, it, hourKey) { return this.expanded.has(this.rowKey(ia,it,hourKey)) },
    toggleRow (ia, it, hourKey) {
      const k = this.rowKey(ia,it,hourKey)
      if (this.expanded.has(k)) this.expanded.delete(k); else this.expanded.add(k)
      // force update
      this.expanded = new Set(this.expanded)
    },
    diaLabel (idx, fechaIso) {
    // “Día 1”, “Día 2”, … — si prefieres sólo la fecha, usa fechaIso
    return `Día ${idx + 1}`
    },
    // Helpers visuales
    hasData (fila, m) { return !!(fila && fila.maquinas && fila.maquinas[m]) },
    getOee (fila, m) {
        if (!this.hasData(fila, m)) return null
        const d = fila.maquinas[m]

        // Si no hubo carga, OEE = 0
        const teor = Number(d.teoricas ?? 0)
        if (teor === 0) return 0

        // Usa OEE del API si viene definido (incluyendo el 0 válido)
        if (d.OEE !== null && d.OEE !== undefined) return Number(d.OEE)

        // Si no viene, recalcúlalo
        const A = Number(d.A ?? 0)
        const P = Number(d.P ?? 0)
        const Q = Number(d.Q ?? 0)
        return (A * P * Q) / 10000
    },
    getOeeDia (d, m) {
        const dm = d?.maquinas?.[m]
        if (!dm) return null

        const teor = Number(dm.teoricas ?? 0)
        if (teor === 0) return 0              // sin carga ⇒ OEE = 0

        if (dm.OEE !== null && dm.OEE !== undefined) return Number(dm.OEE)

        const A = Number(dm.A ?? 0)
        const P = Number(dm.P ?? 0)
        const Q = Number(dm.Q ?? 0)
        return (A * P * Q) / 10000
    },
    getValDia (d, m, key) {
        const dm = d?.maquinas?.[m]
        if (!dm) return null
        const v = dm[key]
        return v != null ? Number(v) : null
    },
    getVal (fila, m, key) {
    if (!this.hasData(fila, m)) return null
    const d = fila.maquinas[m]
    if (Number(d.teoricas||0) === 0) return 0   // << evita el 100% en vacío
    const v = d[key]
    return v != null ? Number(v) : null
    },
    nf (n) { return Number(n ?? 0).toLocaleString() },
    pf (n) { return `${Number(n ?? 0).toFixed(2)}%` },
    pct (n) { return n == null || isNaN(n) ? '—' : `${Number(n).toFixed(2)}%` },
    pad (n) { return String(n).padStart(2, '0') },
    nombreMaquina: m => `[${m.nombre}] - ${m.marca} ${m.modelo}`,
    nfsafe (n) { return (n == null || isNaN(n)) ? '—' : Number(n).toLocaleString() },
    bgStyle (oee) {
    if (oee == null) return { background: '#f3f4f6' }  // neutro sin datos
    const x = Math.max(0, Math.min(100, Number(oee)))
    const r = x < 50 ? 255 : Math.round(255 - (x - 50) * 5.1)
    const g = x < 50 ? Math.round(x * 5.1) : 255
    return { background: `rgba(${r},${g},120,0.18)` }
    },
    // hh:mm + fecha base -> { turno, fechaProd }
    resolveTurnoYDia (hhmm, fechaBase) {
    // hhmm puede venir "05:00", "05:00:00" o "05:00 - 06:00"
    const start = String(hhmm || '').split(/[ -]/)[0];
    const [H, M] = start.split(':').slice(0, 2).map(n => +n || 0);
    const min = H * 60 + M;

    // Turno 1: 07:00–18:59 (mismo día)
    if (min >= 420 && min < 1140) {
        return { turno: 1, fechaProd: fechaBase };
    }

    // Turno 2: 19:00–23:59 (mismo día)
    if (min >= 1140) {
        return { turno: 2, fechaProd: fechaBase };
    }

    // Turno 2: 00:00–06:59 (DÍA SIGUIENTE a fechaBase)
    const d = new Date(`${fechaBase}T00:00:00`);
    d.setDate(d.getDate() + 1);
    return { turno: 2, fechaProd: d.toISOString().slice(0, 10) };
    },

    // catálogos
    async mountedInit () { this.getInstancias(); this.getAreas() },
    async getInstancias () {
      this.loadingInstancias = true
      try { const { data } = await axios.get('/MaquinaInstancias'); this.instancias = data || [] }
      catch (e) { console.error(e) }
      finally { this.loadingInstancias = false }
    },
    async getAreas () {
      this.loadingAreas = true
      try { const { data } = await axios.get('/Areas'); this.areas = data || [] }
      catch (e) { console.error(e) }
      finally { this.loadingAreas = false }
    },

    // API
    async obtenerDatos () {
      if (!this.realizarPeticion) return
      this.start(); this.loading = true; this.expanded.clear()
      try {
        const qs = new URLSearchParams()
        qs.append('desde', this.filtros.desde)
        qs.append('hasta', this.filtros.hasta)
        ;(this.filtros.idMaquinasIns || []).forEach(id => qs.append('idMaquinaIns', id))
        ;(this.filtros.idAreas || []).forEach(id => qs.append('idAreas', id))
        qs.append('sinDisponibilidad', true)
        qs.append('descontarNoOkPorArticulo', false)
        qs.append('desConParosNP', true)
        qs.append('usarApoyoV1ParaPonderados', false)

        const { data } = await axios.get(`/OEECalculos/HoraPorHoraV2PeriodoMulti?${qs.toString()}`)
        this.response = data || null
      } catch (e) {
        console.error(e); this.response = null
      } finally {
        this.loading = false; this.restart()
      }
    },

    // timer
    start () { if (this.isRunning) return; if (this.remainingMs <= 0) this.remainingMs = this.totalMs; this.endAt = Date.now() + this.remainingMs; this.isRunning = true; this.intervalId = setInterval(this.tick, 200) },
    pause () { if (this.intervalId) { clearInterval(this.intervalId); this.intervalId = null } this.isRunning = false },
    reset () { this.pause(); this.remainingMs = this.totalMs },
    restart () { this.reset(); this.start() },
    tick () { this.remainingMs = Math.max(this.endAt - Date.now(), 0); if (this.remainingMs === 0) { this.pause(); this.obtenerDatos() } },
    setMinutes (mins) { this.totalMs = Math.max(0, Number(mins) || 0) * 60 * 1000; this.reset() }
  },

  mounted () { this.mountedInit() },
  watch: {
  areasTurnos: {
        immediate: true,
        handler (list) {
        // abrir TODAS las áreas
        this.expandedAreas = list.map((_, ia) => ia)

        // abrir TODOS los turnos dentro de cada área
        const next = {}
        list.forEach((a, ia) => {
            next[ia] = Array.from({ length: (a.turnos || []).length }, (_, i) => i)
        })
        this.expandedTurnos = next
        }
    },
    minutes (m) { this.setMinutes(m) }
  },
  beforeDestroy () { if (this.intervalId) clearInterval(this.intervalId) }
}
</script>

<style scoped>
.table-wrap{ overflow:auto; border:1px solid rgba(0,0,0,.06); border-radius:12px }
.table-wrap.compacto .matriz{ font-size:12px }
.matriz{ width:100%; border-collapse:separate; border-spacing:0; font-size:13.5px }
.matriz thead th{
  position:sticky; top:0; background:#fafafa; z-index:2; padding:10px 12px;
  border-bottom:1px solid rgba(0,0,0,.08); text-align:center; font-weight:600
}
.matriz tbody td{ padding:8px 10px; border-bottom:1px solid rgba(0,0,0,.04) }
.sticky-col{ position:sticky; left:0; background:#fff; z-index:1; min-width:130px; font-weight:600 }
.cell{ min-width:140px }
.cell.total{ background:#f9fafb }
.cell-content{ text-align:center; line-height:1.15 }
.oee{ font-weight:700 }
.mini{ font-size:11px; opacity:.8 }
.sticky-top{ position:sticky; top:0; background:#fafafa; z-index:2 }
.alerta{ box-shadow: inset 0 0 0 2px rgba(230,60,60,.25) }

/* Detalle por día */
.detalle-wrap{ padding:8px 8px 12px 8px }
.subtabla{
  width:100%;
  border-collapse:separate;
  border-spacing:0;
  font-size:13px;
}
.subtabla thead th{
  position:sticky;
  top:0;               /* queda bajo el thead principal del bloque expandido */
  background:#eef3ff;
  z-index:1;
  padding:8px 10px;
  text-align:center;
  border-bottom:1px solid rgba(0,0,0,.08);
}
.subtabla tbody td{ padding:8px 10px; border-bottom:1px solid rgba(0,0,0,.05); }
.subtabla .sticky-col{
  position:sticky; left:0; background:#f7f9fc; z-index:1; min-width:160px;
}
.detalle-grid {
  display: block;
  padding: 6px 8px 12px 8px;
}

.dg-row {
  display: grid;
  grid-template-columns: 180px repeat(auto-fit, minmax(140px, 1fr)) minmax(160px, 180px);
  gap: 8px;
  align-items: stretch;
  padding: 6px 6px;
  border-bottom: 1px solid rgba(0,0,0,.05);
}

.dg-day {
  position: sticky;
  left: 0;
  background: #f7f9fc;
  z-index: 1;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,.06);
}
.dg-day-title { font-weight: 700; line-height: 1; }
.dg-day-sub   { font-size: 11px; opacity: .8; }

.dg-cell, .dg-total {
  display: flex;
  align-items: stretch;
}

.chip {
  flex: 1;
  border-radius: 10px;
  padding: 8px 10px;
  border: 1px solid rgba(0,0,0,.06);
  background: #fff;
  text-align: center;
}
.chip-empty { background: #f1f5f9; }
.chip-total { background: #eef3ff; }

.chip .oee  { font-weight: 800; }
.chip .mini { font-size: 11px; opacity: .85; }

@media (max-width: 1100px) {
  .dg-row {
    grid-template-columns: 150px repeat(auto-fit, minmax(120px, 1fr)) minmax(140px, 160px);
  }
}
.oee { font-weight: 800; line-height: 1.05; }
.oee-lg { font-size: 18px; }           /* tamaño normal */
.table-wrap.compacto .oee-lg { font-size: 16px; } /* si usas modo compacto */
</style>
